import { COMPLEX, MAJOR, MODERATE } from "../../PreliminaryEtrType";

export const getOutageNotificationVariant = preliminaryEtrType => {
  switch (preliminaryEtrType) {
    case MODERATE:
      return "warning";
    case MAJOR:
    case COMPLEX:
      return "major";
    default:
      return "info";
  }
};
